import { Edge, Node, getBezierPath, MarkerType, ReactFlowInstance, XYPosition } from "@xyflow/react"
import { BaseNodeType } from "./nodes/Base.node"
import { store } from "@/stores/stores"
import { ScenarioNode, ScenarioNodeOnErrorEnum } from "@/gen"
import { BaseEdgeType } from "./Edge"
import { nanoid } from "nanoid"

export function getEdgePath({ sourceX, sourceY, sourcePosition, targetX, targetY, targetPosition }, options?: { edge?: boolean }) {
  let edgePath: [path: string, labelX: number, labelY: number, offsetX: number, offsetY: number]
  // if (targetX > sourceX - 40) {
  edgePath = getBezierPath({
    sourceX: sourceX + (options?.edge ? -14 : 2),
    // sourceX,
    sourceY,
    sourcePosition,
    targetX: targetX + (options?.edge ? -9 : -8),
    // targetX,
    targetY,
    targetPosition,
  })
  // } else {
  //   edgePath = getSmoothStepPath({
  //     sourceX: sourceX + (options?.edge ? -20 : -5),
  //     sourceY: sourceY + 8,
  //     targetX: targetX + (options?.edge ? 35 : 0),
  //     targetY: targetY + (options?.edge ? -44 : -10),
  //     borderRadius: 20,
  //     offset: 80,
  //     centerX: 0,
  //   })
  // }

  return edgePath
}

export const generateNewNodeId = () => {
  // let id
  // try {
  // let idInt = (store.scenario.editing.lastNodeId || 0) + 1
  // const id = idInt + ""
  // store.scenario.editing.lastNodeId = idInt
  // } catch (e) {
  //   id = nanoid(10)
  // }

  return nanoid(7)
}

export function getNewEdgeProps(props?: { color?: string; errorEdge?: boolean }): Partial<Edge> {
  const strokeColor = props?.errorEdge ? "var(--xy-edge-stroke-danger)" : "var(--xy-edge-stroke)"
  return {
    type: "default",
    markerEnd: {
      type: MarkerType.ArrowClosed,
      width: 10,
      height: 10,
      color: strokeColor,
      // color: actionDef.color,
    },
    style: {
      strokeWidth: 4,
      stroke: strokeColor,
      ...(props?.color ? { color: props.color } : {}),
      // stroke: "#FF0072",
    },
  }
}

export const handleNodesRemove = (nodeIds: string[], deleteElements: ReactFlowInstance<Node, Edge>["deleteElements"]) => {
  const nodeIdsRecord = nodeIds.reduce((acc, nodeId) => ({ ...acc, [nodeId]: true }), {})
  store.scenario.actions.setDeletedNodes(nodeIdsRecord)

  // Aguarda a animação terminar antes de remover o nó
  setTimeout(() => {
    deleteElements({
      nodes: nodeIds.map((nodeId) => ({ id: nodeId })),
    })
  }, 150) // Tempo da animação (ms)
}

export function getPositionWithMinDistance(sourceX, sourceY, targetX, targetY, minDistance) {
  // Calcula a diferença entre as posições
  const dx = targetX - sourceX
  const dy = targetY - sourceY

  // Calcula a distância atual entre os pontos
  const distance = Math.sqrt(dx * dx + dy * dy)

  // Se a distância for menor que a mínima, ajusta a posição do target
  if (distance < minDistance) {
    // Normaliza o vetor (dx, dy) para obter a direção
    const angle = Math.atan2(dy, dx)

    // Define o novo target mantendo a direção, mas com a distância mínima
    const newTargetX = sourceX + Math.cos(angle) * minDistance
    const newTargetY = sourceY + Math.sin(angle) * minDistance

    return { x: newTargetX, y: newTargetY }
  }

  // Se a distância já é suficiente, mantém a posição original do target
  return { x: targetX, y: targetY }
}

export function isWithinMinDistance(sourceX, sourceY, targetX, targetY, minDistance) {
  // Calcula a diferença entre as posições
  const dx = targetX - sourceX
  const dy = targetY - sourceY

  // Calcula a distância euclidiana entre os pontos
  const distance = Math.sqrt(dx * dx + dy * dy)

  // Retorna true se estiver dentro da distância mínima, false caso contrário
  return distance < minDistance
}

export function transformScenarioNodesToFlowNodesAndEdges(nodes: ScenarioNode[]) {
  let flowNodes: BaseNodeType[] = []
  let flowEdges: BaseEdgeType[] = []

  // let lastNodeId = 0

  nodes.forEach((node) => {
    const { id, position, type, targets } = node
    flowNodes.push({ id: node.id, type: "base", position: { x: position.x, y: position.y }, data: { ...node, node_type: type } })

    // if (Number(id) > lastNodeId) {
    //   lastNodeId = Number(id)
    // }

    Object.entries(targets || {}).forEach(([sourceHandle, targetId]) => {
      flowEdges.push({
        id: `${id}-${targetId}`,
        source: id,
        target: targetId,
        sourceHandle,
        // Defaults
        "style": {
          "strokeWidth": 4,
          "stroke": "var(--xy-edge-stroke)",
          "color": "#10b981"
        },
        type: "default",
        markerEnd: {
          type: MarkerType.ArrowClosed,
          width: 10,
          height: 10,
          color: "var(--xy-edge-stroke)",
        },
      })
    })
  })

  return {
    nodes: flowNodes,
    edges: flowEdges,
    // lastNodeId,
  }
}

export function transformFlowNodesAndEdgesToScenarioNodes(nodes: BaseNodeType[], edges: BaseEdgeType[]) {
  const scenarioNodes: ScenarioNode[] = []

  nodes.forEach((node) => {
    const { id, type, position, data } = node
    const { node_type, ...restData } = data
    const targets = {}
    edges.filter((edge) => edge.source === id && !!nodes.find((node) => node.id === edge.target)).forEach((edge) => {
      const { sourceHandle } = edge
      if (sourceHandle) {
        targets[sourceHandle] = edge.target
      }
    })
    scenarioNodes.push({ ...restData, id, type: node_type, position, targets })
  })

  return scenarioNodes
}
